// utils/scheduleUtils.js
export const calculateScheduleFrequency = (date_time, frequencyday, repeatFrequency, freq) => {
    if (
        repeatFrequency === "day" &&
        frequencyday?.length > 0 &&
        typeof date_time === 'string' &&
        date_time.includes('T')
    ) {
        const [selectedDatePart, selectedTimePart] = date_time.split('T');
        const [selectedHourPart, selectedminutePart] = selectedTimePart.split(':');
        let parts;
        if (freq === 1) {
            parts = frequencyday[0].trim().split(/[, ]+/);
        } else {
            parts = frequencyday[1].trim().split(/[, ]+/);
        }
        
        const month = parseInt(parts.pop(), 10);
        const days = parts.map(Number);
        const hours = parseInt(selectedHourPart, 10);
        const minutes = parseInt(selectedminutePart, 10);
        const year = new Date().getFullYear();

        const utcDays = days.map(day => {
            const localDate = new Date(year, month - 1, day, hours, minutes);
            const utcDay = localDate.getUTCDate();
            return utcDay;
        });

        return `${utcDays.join(",")} ${month}`;
    }
    return "";
};